import ExpandDownIcon from "@diligentcorp/atlas-react-icons/ExpandDown.js";
export const getDropdownTokens = (tokens) => {
    return {
        dropdown: tokens.component.dropdown,
        input: tokens.component.input,
        spacing: tokens.semantic.spacing,
    };
};
const iconStyles = (tokens) => {
    const { input, dropdown } = getDropdownTokens(tokens);
    return {
        color: dropdown.icon.color.value,
        "&.Mui-disabled": {
            color: input.disabled.icon.color.value,
        },
    };
};
const selectPaddingStyles = (tokens) => {
    const { dropdown, input } = getDropdownTokens(tokens);
    return {
        paddingLeft: dropdown.paddingHorizontal.value,
        paddingRight: parseInt(input.icon.width.value) +
            parseInt(input.gap.value) * 2 +
            parseInt(dropdown.paddingHorizontal.value),
    };
};
const select = (tokens) => {
    const { dropdown, input, spacing } = getDropdownTokens(tokens);
    return {
        MuiSelect: {
            defaultProps: {
                IconComponent: ExpandDownIcon,
            },
            styleOverrides: {
                root: {
                    // Note: this also takes effect in NativeSelect
                    padding: 0,
                },
                select: {
                    "&&&": selectPaddingStyles(tokens),
                    minHeight: parseInt(dropdown.height.value) - 2 * parseInt(dropdown.paddingVertical.value),
                },
                multiple: {
                    "&&&": {
                        paddingLeft: spacing.none.value,
                        paddingRight: spacing.none.value,
                    },
                },
                icon: ({ ownerState }) => (Object.assign(Object.assign(Object.assign({}, iconStyles(tokens)), { right: input.paddingHorizontal.value, top: `calc(50% - (${input.icon.height.value} / 2))`, transition: "none", transform: "none" }), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.open) && {
                    "&&": {
                        transform: "none",
                    },
                }))),
            },
        },
        MuiNativeSelect: {
            defaultProps: {
                IconComponent: ExpandDownIcon,
            },
            styleOverrides: {
                select: {
                    "&&&": selectPaddingStyles(tokens),
                },
                multiple: {
                    height: "auto",
                    "&&": {
                        padding: spacing.none.value,
                    },
                    option: {
                        padding: `${dropdown.item.paddingVertical.value} ${dropdown.item.paddingHorizontal.value}`,
                        "&:checked": {
                            backgroundColor: dropdown.item.selected.backgroundColor.value,
                        },
                    },
                },
                icon: iconStyles(tokens),
            },
        },
    };
};
export default select;
//# sourceMappingURL=select.js.map